// src/App.js

import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

// assets
import batch22Logo from "./assets/batch22_logo.png";
//import communityicon from "./assets/community_icon.png";
import documenticon from "./assets/document_icon.png";
//import projecticon from "./assets/project_icon.png";
import featured1 from "./assets/featured1.png";
import featured2 from "./assets/featured2.png";
import featured3 from "./assets/featured3.png";
import featured4 from "./assets/featured4.png";
import homepage from "./assets/homepage.jpg";

// pages/components
import VisitorPage from "./comps/visitorpage";
import ProjEventList from "./comps/projeventlist";
import EventsPage from "./comps/eventspage";
import AboutUs from "./comps/aboutus";
import CommPage from "./comps/commpage";
import LoginPage from "./comps/LoginPage";
import CreateAccount from "./comps/CreateAccount";
import PaymentConfirmation from "./comps/PaymentConfirmation";
import DonationPage from "./comps/DonationPage";
import CommunityMembers from "./comps/CommunityMembers";
import AccountDropdown from "./comps/AccountDropdown";

// shared “nice frame” for most images
const frameClasses =
  "rounded-2xl border-4 border-[#800000] shadow-lg overflow-hidden";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<VisitorPage />} />
        <Route path="/projects" element={<ProjEventList />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/community" element={<CommPage />} />
        <Route path="/community-members" element={<CommunityMembers />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route
          path="/payment-confirmation"
          element={<PaymentConfirmation />}
        />
        <Route path="/donate" element={<DonationPage />} />
      </Routes>
    </Router>
  );
}

export const Navbar = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const isLoggedIn = !!localStorage.getItem("token");

  return (
    <nav className="bg-white py-4 shadow-sm">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center space-x-2">
          <img src={batch22Logo} alt="Batch-22 Logo" className="h-10 w-auto" />
          <div className="text-black font-bold text-xl leading-tight">
            SPREEHA <br /> BUET-88 FOUNDATION
          </div>
        </Link>
        <div className="flex space-x-6 text-black font-medium items-center">
          <Link to="/about" className="hover:text-gray-700">
            about us
          </Link>
          <span className="hover:text-gray-700 cursor-default">
            contact us
          </span>
          {isLoggedIn ? (
            <div
              className="relative"
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
            >
              <button className="hover:text-gray-700 flex items-center space-x-1">
                <span>account</span>
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {showDropdown && <AccountDropdown />}
            </div>
          ) : (
            <Link to="/login" className="hover:text-gray-700">
              login
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export const MissionSection = ({ imageClassName }) => (
  <section className="bg-white py-16">
    <div className="container mx-auto flex flex-col lg:flex-row items-center gap-12">
      <div className="lg:w-1/2 space-y-6">
        <h1 className="text-black text-5xl font-bold">Our Mission</h1>
        <p className="text-black text-lg leading-relaxed">
          Spreeha BUET 88 Foundation is a non-profit organization established
          by alumni of the 1988-89 batch at BUET with a mission to contribute to
          social welfare and charitable activities in Bangladesh. Founded in
          2012, the foundation aims to foster cohesiveness among alumni globally
          while promoting humanitarian efforts both locally and
          internationally.
        </p>
        <div className="pt-2">
          <Link to="/about">
            <button className="bg-[#800000] text-white font-bold py-2 px-6 rounded-lg hover:bg-[#9b0000] transition">
              About Us
            </button>
          </Link>
        </div>
      </div>
      <div className="lg:w-1/2">
        <img
          src={homepage}
          alt="Our mission illustration"
          className={
            imageClassName ??
            `w-full ${frameClasses}`
          }
        />
      </div>
    </div>
  </section>
);

export const ProjectsSection = ({
  header,
  para,
  btnName,
  imagePath,
  imageFirst,
  imageClassName,
  linkTo,
}) => (
  <section className="bg-white py-16">
    <div className="container mx-auto flex flex-col lg:flex-row items-center gap-12">
      {imageFirst && (
        <div className="lg:w-1/2">
          <img
            src={imagePath}
            alt={header}
            className={
              imageClassName ??
              `w-full ${frameClasses}`
            }
          />
        </div>
      )}
      <div className="lg:w-1/2 space-y-6">
        <h1 className="text-black text-5xl font-bold">{header}</h1>
        <p className="text-black text-lg">{para}</p>
        <div className="pt-2">
          <Link to={linkTo || "/projects"}>
            <button className="bg-[#800000] text-white font-bold py-2 px-6 rounded-lg hover:bg-[#9b0000] transition">
              {btnName}
            </button>
          </Link>
        </div>
      </div>
      {!imageFirst && (
        <div className="lg:w-1/2">
          <img
            src={imagePath}
            alt={header}
            className={
              imageClassName ??
              `w-full ${frameClasses}`
            }
          />
        </div>
      )}
    </div>
  </section>
);

export const Testimonials = () => {
  const items = [
    {
      name: "OPRAH WINFREY",
      quote:
        "When we share our blessings, we multiply hope in the lives of others.",
    },
    {
      name: "MALALA YOUSAFZAI",
      quote:
        "One small act of kindness can start a wave of change.",
    },
    {
      name: "BILL GATES",
      quote:
        "Giving isn't just about money—it's about creating lasting change for those who need it most.",
    },
  ];
  return (
    <section className="bg-white py-16">
      <div className="container mx-auto text-center space-y-6">
        <h2 className="text-sm font-bold uppercase text-gray-600">
          Inspiration
        </h2>
        <h1 className="text-black text-3xl font-bold">
          The Spirit of Giving
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
          {items.map((t, i) => (
            <div
              key={i}
              className="bg-[#800000] rounded-lg p-6 text-white shadow-lg"
            >
              <h3 className="font-bold mb-2">{t.name}</h3>
              <p className="italic">"{t.quote}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const FeaturedOn = () => {
  const brands = [
    { name: "TechCrunch", logo: featured1 },
    { name: "FastCompany", logo: featured2 },
    { name: "MIT", logo: featured3 },
    { name: "Forbes", logo: featured4 },
  ];
  return (
    <section className="bg-white py-16">
      <div className="container mx-auto text-center space-y-4">
        <h2 className="text-lg font-bold uppercase text-gray-600">
          Featured In
        </h2>
        <div className="flex justify-around items-center flex-wrap gap-6">
          {brands.map((b, i) => (
            <img
              key={i}
              src={b.logo}
              alt={`${b.name} Logo`}
              className="h-12 w-auto"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export const Resources = () => (
  <section className="bg-white py-16">
    <div className="container mx-auto flex flex-col lg:flex-row items-center gap-12">
      <div className="lg:w-1/2 space-y-6">
        <h1 className="text-black text-5xl font-bold">Resources</h1>
        <p className="text-black text-lg">
          Learn more about our reports, galleries, and FAQs.
        </p>
        <div className="flex flex-wrap gap-4">
          <a
            href="https://docs.google.com/document/d/1BsBJLnQrNFEwfBB1Ygm8EJpuqpGej3N-/edit?rtpof=true"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-transparent border-2 border-[#800000] text-[#800000] py-2 px-6 rounded-full font-bold hover:bg-[#800000] hover:text-white transition"
          >
            Reports
          </a>
          <a
            href="https://drive.google.com/drive/folders/1zF4kpe1vF5XCi6uK9SnYzF4B9j8kbMTl"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-transparent border-2 border-[#800000] text-[#800000] py-2 px-6 rounded-full font-bold hover:bg-[#800000] hover:text-white transition"
          >
            Gallery
          </a>
          <button className="bg-transparent border-2 border-[#800000] text-[#800000] py-2 px-6 rounded-full font-bold hover:bg-[#800000] hover:text-white transition">
            FAQs
          </button>
        </div>
      </div>
      {/* NO frame here, just original sizing */}
      <div className="lg:w-1/2">
        <img
          src={documenticon}
          alt="Resources"
          className="w-1/2 lg:w-1/3 rounded-lg"
        />
      </div>
    </div>
  </section>
);

export default App;
